import {
    FaFacebookF,
    FaInstagram,
    FaBehance,
    FaLinkedin,
    FaYoutube,
    FaGoogle,
    FaApple,
    FaFigma,
    FaReddit,
    FaDiscord,
    FaTiktok,
    FaTumblr,
    FaTelegram,
    FaPinterest,
    FaGithub,
    FaWhatsapp,
    FaSkype,
    FaSpotify,
} from 'react-icons/fa'
import {
    FaSnapchat,
    FaMedium,
    FaXTwitter,
    FaGoogleScholar,
    FaWeixin,
} from 'react-icons/fa6'

export const DataIcons = [
    { id: 1, name: 'Facebook', icon: FaFacebookF },
    { id: 2, name: 'Behance', icon: FaBehance },
    { id: 3, name: 'Instagram', icon: FaInstagram },
    { id: 4, name: 'LinkedIn', icon: FaLinkedin },
    { id: 5, name: 'Google', icon: FaGoogle },
    { id: 6, name: 'Youtube', icon: FaYoutube },
    { id: 7, name: 'Apple', icon: FaApple },
    { id: 8, name: 'Snapchat', icon: FaSnapchat },
    { id: 9, name: 'Figma', icon: FaFigma },
    { id: 10, name: 'Reddit', icon: FaReddit },
    { id: 11, name: 'Discord', icon: FaDiscord },
    { id: 12, name: 'Tiktok', icon: FaTiktok },
    { id: 13, name: 'Tumblr', icon: FaTumblr },
    { id: 14, name: 'Telegram', icon: FaTelegram },
    { id: 15, name: 'Pinterest', icon: FaPinterest },
    { id: 16, name: 'Github', icon: FaGithub },
    { id: 17, name: 'WhatsApp', icon: FaWhatsapp },
    { id: 18, name: 'Skype', icon: FaSkype },
    { id: 19, name: 'Spotify', icon: FaSpotify },
    { id: 20, name: 'Twitter', icon: FaXTwitter },
    {
        id: 21,
        name: 'Google_Scholar',
        placeholder: 'Google Scholar',
        icon: FaGoogleScholar,
    },
    { id: 22, name: 'Medium', placeholder: 'Medium', icon: FaMedium },
    { id: 23, name: 'WeChat', placeholder: 'WeChat', icon: FaWeixin },
]

export function normalizePlatformKey(name) {
    return String(name)
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_')
}

export function findPlatformIcon(platform) {
    const key = normalizePlatformKey(platform)
    return DataIcons.find(
        item => normalizePlatformKey(item.name) === key,
    )
}
